import { useCallback, useEffect, useState } from 'react';

export default function useEventTriggered(event = () => {}, override = false) {
	const [hasHappened, setHasHappened] = useState(false);

	useEffect(() => {
		if (!hasHappened) setHasHappened(override);
	}, [hasHappened, override]);

	return [
		hasHappened,
		useCallback(
			(...params) => {
				event(...params);
				setHasHappened(true);
			},
			[event]
		)
	];
}
